import { takeEvery, fork, put, all, call } from "redux-saga/effects"

//Account Redux states
import { REGISTER_USER, GET_PASSWORD, CREATE_NEW_USER } from "./actionTypes"
import { registerUserSuccessful, registerUserFailed, getPasswordSuccessful, getPasswordFailed, createNewUserSuccessful, createNewUserFailed } from "./actions"
import { loadStripe } from '@stripe/stripe-js';
//Include Both Helper File with needed methods
import {
  createStripeUser, getCustomerId, subscribeOnboardSequence, postLogin, createSageUser, createCognitoUser, addToken, getRegisterPassword
} from "../../../helpers/fakebackend_helper"

// initialize relavant method of both Auth

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }) {
  try {
    console.log(user)
    const response = yield call (createStripeUser, user)
    user.sessionId = response.id
    console.log(user)
    yield put(registerUserSuccessful(user))
  } catch (error) {
    yield put(registerUserFailed(error))
  }
}

function* createNewSageUser({ payload: { user } }) {
  try {
    console.log(user)
    yield call (createCognitoUser, user)   
    var response = yield call(postLogin, {
      username: user.username,
      password: user.password
    })
    yield call(addToken, response)
    yield call(subscribeOnboardSequence, user)
    var customerId = yield call (getCustomerId, user.sessionId)
    user.customer_id = customerId
    console.log("Customer id " + customerId)
    var sageUser = yield call (createSageUser, user)
    console.log(sageUser)
    yield put(createNewUserSuccessful(sageUser))
  } catch (error) {
    yield put(createNewUserFailed(error))
  }
}


function* getPassword({ payload: { password } }) {
  try {
    const response = yield call (getRegisterPassword, password)
    console.log(response)
    yield put(getPasswordSuccessful(response.password))
  } catch (error) {
    yield put(getPasswordFailed(error))
  }
}


export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser)
  yield takeEvery(GET_PASSWORD, getPassword)
  yield takeEvery(CREATE_NEW_USER, createNewSageUser)
}

function* accountSaga() {
  yield all([fork(watchUserRegister)])
}

export default accountSaga
